import {
    Modal,
    ModalContent,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Button
} from '@nextui-org/react'
import { ReactNode } from 'react'

import { Text } from '@/components/common/UI'

interface ConfirmDialogProps {
    isOpen: boolean
    onOpenChange: (isOpen: boolean) => void
    title: string
    message: string | ReactNode
    cancelText?: string
    confirmText?: string
    confirmColor?:
        | 'default'
        | 'primary'
        | 'secondary'
        | 'success'
        | 'warning'
        | 'danger'
    icon?: ReactNode
    onConfirm: () => void
    onCancel?: () => void
    backdrop?: 'transparent' | 'opaque' | 'blur'
    placement?: 'auto' | 'top' | 'bottom' | 'center'
}

export function ConfirmDialog({
    isOpen,
    onOpenChange,
    title,
    message,
    cancelText = 'Cancelar',
    confirmText = 'Aceptar',
    confirmColor = 'primary',
    icon,
    onConfirm,
    onCancel,
    backdrop = 'opaque',
    placement = 'center'
}: ConfirmDialogProps) {
    const handleCancel = () => {
        if (onCancel) {
            onCancel()
        }
        onOpenChange(false)
    }

    return (
        <Modal
            isOpen={isOpen}
            onOpenChange={onOpenChange}
            backdrop={backdrop}
            placement={placement}
        >
            <ModalContent>
                <ModalHeader>
                    <div className="flex items-center gap-2">
                        {icon}
                        <span>{title}</span>
                    </div>
                </ModalHeader>
                <ModalBody>
                    {typeof message === 'string' ? (
                        <Text text={message} />
                    ) : (
                        message
                    )}
                </ModalBody>
                <ModalFooter className="flex justify-between">
                    <Button
                        variant="light"
                        onClick={handleCancel}
                    >
                        {cancelText}
                    </Button>
                    <Button
                        color={confirmColor}
                        onClick={onConfirm}
                    >
                        {confirmText}
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    )
}
